module.exports = __webpack_public_path__ + "static/1-ea41e235982ebab2154509264e4ce863.jpg";